export default "__VITE_ASSET__cyd4X41x__"